import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import * as Sentry from '@sentry/react';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';
import reportWebVitals from './reportWebVitals';

Sentry.init({
  dsn: "https://b24e16823d43fd149efaf821b54fb0e0@o4511389849354241.ingest.de.sentry.io/4511389853876304",
  environment: window.location.hostname.includes("localhost") ? "dev" : "production",
  enabled: !window.location.hostname.includes("localhost"),
  tracesSampleRate: 0.2,
});

const root = ReactDOM.createRoot(document.getElementById('root'));root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
